import "./Toggle.scss";

import Tooltip from "components/Tooltip/Tooltip";

type ToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  leftLabel?: string;
  rightLabel?: string;
  disabled?: boolean;
  tooltipMessage?: string;
};

const Toggle = ({
  checked,
  onChange,
  leftLabel,
  rightLabel,
  disabled,
  tooltipMessage,
}: ToggleProps) => {
  const toggleElement = (
    <label className="toggle">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className="slider" />
    </label>
  );

  const wrappedToggle =
    tooltipMessage && disabled ? (
      <Tooltip content={tooltipMessage} variant="info">
        {toggleElement}
      </Tooltip>
    ) : (
      toggleElement
    );

  return (
    <div className="toggle-container">
      {leftLabel && (
        <span className={!checked ? "active" : ""}>{leftLabel}</span>
      )}
      {wrappedToggle}
      {rightLabel && (
        <span className={checked ? "active" : ""}>{rightLabel}</span>
      )}
    </div>
  );
};

export default Toggle;
